import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserEventService } from '@anecdotes/user-event-core';
import { SupportActions } from '@anecdotes/support';
import { tap } from 'rxjs';
import { WindowHelperService } from '@anecdotes/utils';

@Injectable()
export class UserEventsEffects {
  constructor(
    private actions: Actions,
    private userEventService: UserEventService,
    private windowHelper: WindowHelperService,
  ) {}

  trackSupportRequestCreated$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(SupportActions.supportRequestCreated),
        tap(() => {
          const source = this.windowHelper.getLocation().pathname;
          this.userEventService.sendEvent('Zendesk request was created', { source });
        }),
      ),
    { dispatch: false },
  );
}
